const EASYBIB_TAG = 'EasyBib:Bibliography'

/**
 * This creates a ContentControl (labeled region) in the document
 * @param Range The area in the document we assign the ContentControl to
 * @return ContentControl
 */
function createBibliography(range) {
  const contentControl = range.insertContentControl()
  contentControl.tag = EASYBIB_TAG
  contentControl.appearance = 'hidden'
  return contentControl
}

/**
 * If an earlier bibliography exists, delete it
 * @param ContentControlCollection
 * @return Bool
 */
function deleteExistingBibliography(contentControls) {
  if (contentControls.items.length > 0) {
    contentControls.items.forEach(item => item.delete())
    return true
  }
  return false
}

/**
 * All citations should have a center aligned title and a hanging indent
 * @param ParagraphCollection Paragraphs in the bibliography
 * @param String
 * @return void
 */
function applyFormat(paragraphs) {
  paragraphs.items.forEach((item, i) => {
    const paragraph = item
    if (i === 0) { // title
      paragraph.alignment = 'centered'
      return
    }
    paragraph.firstLineIndent = -36
    paragraph.leftIndent = 36
    paragraph.lineSpacing = 24
  })
}

function formatBibliography(context, bibliographyContentControl) {
  const paragraphs = bibliographyContentControl.paragraphs
  context.load(paragraphs, 'text')
  context.sync().then(() => {
    applyFormat(paragraphs)
    return context.sync()
  })
}

function updateBibliography(html) {
  const Word = window.Word
  return Word.run((context) => {
    const easybibContentControls = context.document.contentControls.getByTag(EASYBIB_TAG)
    context.load(easybibContentControls)
    return context.sync().then(() => {
      if (!deleteExistingBibliography(easybibContentControls)) {
        context.document.body.insertBreak('page', 'end')
      }
      return context.sync()
    }).then(() => {
      const bibliographyContentControl = createBibliography(
        context.document.body.insertHtml(html, 'end')
      )
      formatBibliography(context, bibliographyContentControl)
      return context.sync()
    })
    .catch((e) => {
      console.log(`Error: ${e}`) // eslint-disable-line no-console
      return Promise.reject()
    })
  })
}

function createCitationHtml(citations) {
  let citationStrings = []
  citations.forEach(citation => {
    const formattedCitation = citation.formattedString || (citation.formatted_data ? citation.formatted_data.output : '...')
    citationStrings.push({'formatted': formattedCitation, 'stripped': formattedCitation.replace(/[^0-9a-z ]/gi, '')});
  })

  citationStrings.sort(function(a, b) {
        if (a.stripped < b.stripped) {
            return -1;
        }
        if (a.stripped > b.stripped) {
            return 1;
        }
        return 0;
    })

  let citationsHTML = ''
  citationStrings.forEach(sortedCitations => {
    const citationHTML = sortedCitations.formatted
    citationsHTML += `<p>${citationHTML}</p>`
  })
  return citationsHTML
}

export function updateCitations(citations, style) {
  let title = 'Bibliography'
  if (style.startsWith('chicago')) {
    title = 'References'
  } else if (style.startsWith('mla')) {
    title = 'Works Cited'
  }
  const html = `\n<p>${title}</p>\n${createCitationHtml(citations)}`
  return updateBibliography(html)
}

export function openUrlInDialog(url) {
  const width = 800
  const height = 650
  const options = { height, width, displayInFrame: false }
  // From https://dev.office.com/reference/add-ins/shared/officeui.displaydialogasync
  // the docs says that options.displayInFrame (false by default) is recommended to true
  // but it does nothing in chrome
  window.Office.context.ui.displayDialogAsync(url, options)
}




// WEBPACK FOOTER //
// ./src/wordApi.js